import React from "react";
import { motion } from "framer-motion";
import { Volume2 } from "lucide-react";

const soundLabel = () => ((localStorage.getItem("argali_lang") || "ru") === "en" ? "Enable sound" : "Включить звук");

// Branded entrance — ram emblem + thin horn-inspired ring draw.
export const BrandLoader = () => (
  <motion.div
    data-testid="brand-loader"
    className="fixed inset-0 z-[200] flex items-center justify-center grain"
    style={{ background: "#11110F" }}
    initial={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
  >
    <div className="relative flex flex-col items-center">
      <svg viewBox="0 0 120 120" className="absolute w-40 h-40 md:w-52 md:h-52" style={{ transform: "translateY(-6px)" }}>
        <motion.circle
          cx="60" cy="60" r="54" fill="none" stroke="#A96818" strokeWidth="1" strokeLinecap="round"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 0.9 }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          style={{ rotate: -90, transformOrigin: "center" }}
        />
      </svg>
      <motion.img
        src="/brand/argali_emblem_ru_v2.png"
        alt="Логотип АРГАЛИ"
        width="543"
        height="501"
        className="w-24 md:w-28 h-auto"
        initial={{ opacity: 0, scale: 0.86 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.span
        className="font-serif text-2xl tracking-[0.4em] text-argali-ivory mt-5 pl-[0.4em]"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.4 }}
      >
        АРГАЛИ
      </motion.span>
      <motion.button
        data-testid="loader-sound-invite"
        onClick={() => window.dispatchEvent(new Event("argali:enable-sound"))}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.9 }}
        className="mt-8 inline-flex items-center gap-2 text-[0.62rem] uppercase tracking-[0.22em] text-argali-sandstone/70 hover:text-argali-gold transition-colors"
      >
        <Volume2 size={14} /> {soundLabel()}
      </motion.button>
    </div>
  </motion.div>
);

export default BrandLoader;
